/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Submit_ErrorInputs */

const vi_stocktake_submit_error = /** @type {(inputs: Stocktake_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không submit được phiếu`)
};

/**

* @param {Stocktake_Submit_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_submit_error = /** @type {((inputs?: Stocktake_Submit_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Submit_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_submit_error(inputs)
});